<template>
    <div>
        <vue-headful :title="form.form_name + ' [Inspection Forms] :: MeritEHS'" />

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/inspections/forms`">
                        <i class="fa fa-clipboard"></i> Inspection Forms
                    </router-link>
                </li>
                <li class="breadcrumb-item active">{{ form.form_name }}</li>
            </ol>
        </h4>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-xl-8">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Form Details</strong>
                            <div class="float-sm-right" v-if="this.$store.state.user.is_admin">
                                <router-link :to="`/inspections/forms/publish/${form.inspection_form_id}`" class="btn btn-sm btn-light" v-if="!form.published_at">
                                    <i class="fa fa-flag-checkered"></i> Publish
                                </router-link>
                                <router-link :to="`/inspections/forms/delete/${form.inspection_form_id}`" class="btn btn-sm btn-light" v-if="!form.published_at">
                                    <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                                </router-link>

                                <b-dropdown variant="light" size="sm" v-if="form.published_at">
                                    <template slot="button-content">
                                        <i class="fa fa-file-o"></i> Export
                                    </template>
                                    <b-dropdown-item href="javascript:void(0)" v-on:click="exportForm()" :disabled="exporting">
                                        <i class="fa fa-file-excel-o"></i> Excel
                                    </b-dropdown-item>
                                    <b-dropdown-item href="javascript:void(0)" v-on:click="sendToPDF()" :disabled="exporting">
                                        <i class="fa fa-file-pdf-o"></i> PDF
                                    </b-dropdown-item>
                                </b-dropdown>

                                <router-link :to="`/inspections/forms/edit/${form.inspection_form_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/inspections/forms/clone/${form.inspection_form_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-copy"></i> Clone
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-md-6">
                                    <div class="row mb-2">
                                        <div class="col-md-5 text-muted">Form Name</div>
                                        <div class="col-md-7">{{ form.form_name }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-5 text-muted">Active:</div>
                                        <div class="col-md-7">
                                            <label class="badge badge-success" v-if="form.is_active == 1">Active</label>
                                            <label class="badge badge-warning" v-else>Inactive</label>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-5 text-muted">Published:</div>
                                        <div class="col-md-7">
                                            <template v-if="form.published_at">
                                            {{ form.published_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
                                            </template>
                                            <template v-else>
                                                --
                                            </template>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-5 text-muted">Hide Equipment:</div>
                                        <div class="col-md-7">
                                            <label class="badge badge-success" v-if="form.hide_equipment == 1">Yes</label>
                                            <label class="badge badge-default" v-else>NO</label>
                                        </div>
                                    </div>
                                    <div class="row mb-2" v-if="form.hide_equipment == 0">
                                        <div class="col-md-5 text-muted">Require Equipment:</div>
                                        <div class="col-md-7">
                                            <label class="badge badge-success" v-if="form.req_equipment == 1">Yes</label>
                                            <label class="badge badge-default" v-else>No</label>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-5 text-muted">Require # of Employees on Site:</div>
                                        <div class="col-md-7">
                                            <label class="badge badge-success" v-if="form.req_num_of_employees == 1">Yes</label>
                                            <label class="badge badge-default" v-else>NO</label>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-5 text-muted">Require Additional Files & Photos:</div>
                                        <div class="col-md-7">
                                            <label class="badge badge-success" v-if="form.req_add_files_and_photos == 1">Yes</label>
                                            <label class="badge badge-default" v-else>NO</label>
                                        </div>
                                    </div>
                                    <template v-if="$store.state.user.enable_public_insp_forms">
                                        <div class="row mb-2">
                                            <div class="col-md-5 text-muted">Public:</div>
                                            <div class="col-md-7">
                                                <label class="badge badge-success" v-if="form.is_public_form == 1">Yes</label>
                                                <label class="badge badge-default" v-else>No</label>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-5 text-muted">Hide Creator:</div>
                                            <div class="col-md-7">
                                                <label class="badge badge-success" v-if="form.hide_creator == 1">Yes</label>
                                                <label class="badge badge-default" v-else>No</label>
                                            </div>
                                        </div>
                                        <div class="row mb-2" v-if="form.is_public_form == 1">
                                            <div class="col-md-5 text-muted">Disable Edit:</div>
                                            <div class="col-md-7">
                                                <label class="badge badge-success" v-if="form.disable_edit_mode == 1">Yes</label>
                                                <label class="badge badge-default" v-else>No</label>
                                            </div>
                                        </div>
                                        <div class="row mb-2" v-if="form.is_public_form == 1">
                                            <div class="col-md-5 text-muted">Enable File Uploads:</div>
                                            <div class="col-md-7">
                                                <label class="badge badge-success" v-if="form.enable_file_uploads == 1">Enabled</label>
                                                <label class="badge badge-default" v-else>Disabled</label>
                                            </div>
                                        </div>
                                        <div class="row mb-2" v-if="form.is_public_form == 1">
                                            <div class="col-md-5 text-muted">Enable Corrective Actions:</div>
                                            <div class="col-md-7">
                                                <label class="badge badge-success" v-if="form.enable_corrective_actions == 1">Enabled</label>
                                                <label class="badge badge-default" v-else>Disabled</label>
                                            </div>
                                        </div>
                                        <div class="row mb-2" v-if="$store.state.user.enable_module_mic == 1">
                                            <div class="col-md-5 text-muted">Include on MIC:</div>
                                            <div class="col-md-7">
                                                <label class="badge badge-success" v-if="form.add_to_hse_partic_export == 1">Yes</label>
                                                <label class="badge badge-default" v-else>No</label>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-5 text-muted">Hide Superintendent:</div>
                                            <div class="col-md-7">
                                                <label class="badge badge-success" v-if="form.hide_superintendent == 1">Yes</label>
                                                <label class="badge badge-default" v-else>No</label>
                                            </div>
                                        </div>
                                        <div class="row mb-2" v-if="form.hide_superintendent == 0">
                                            <div class="col-md-5 text-muted">Require Superintendent:</div>
                                            <div class="col-md-7">
                                                <label class="badge badge-success" v-if="form.req_superintendent == 1">Yes</label>
                                                <label class="badge badge-default" v-else>No</label>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="col-md-6">
                                    <div class="row mb-2">
                                        <div class="col-md-5 text-muted">Total Custom Fields:</div>
                                        <div class="col-md-7">{{ custom_field_count }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-5 text-muted">Total Sections:</div>
                                        <div class="col-md-7">{{ form.total_sections }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-5 text-muted">Total Elements:</div>
                                        <div class="col-md-7">{{ form.total_elements }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-5 text-muted">Total Form Score:</div>
                                        <div class="col-md-7">{{ total_score }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-5 text-muted">Total Inspections Completed:</div>
                                        <div class="col-md-7">{{ form.total_inspections }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-2" v-if="$store.state.user.enable_public_insp_forms && form.is_public_form == 1">
                                <label class="text-muted">Link to Access Public Forms:</label><br/>
                                <a :href="`/inspections/public/${sds_key}/create?inspection_form_id=${form.inspection_form_id}`">{{ this.$root.appUrl }}/inspections/public/{{ sds_key }}/create?inspection_form_id={{ form.inspection_form_id }}</a>
                            </div>

                            <div class="mb-2" v-if="$store.state.user.req_public_insp_form_password && form.is_public_form == 1">
                                <label class="text-muted">Public Access Password:</label><br/>
                                {{ form.public_insp_form_password }}
                            </div>

                            <div v-if="form.is_public_form !== 1 || form.enable_corrective_actions == 1">
                                <label class="text-muted">Require Corrective Actions for {{ (form.result_labels && form.result_labels.noncompliant ? form.result_labels.noncompliant : 'Non-Compliant') }} Results:</label>
                                <label class="badge badge-success" v-if="form.req_corrective_actions == 1">Yes</label>
                                <label class="badge badge-danger" v-else>No</label>
                            </div>
                        </div>
                    </div>

                    <personnel-view :personnel="personnel" />
                    <br/>

                    <h5 class="mt-4">Inspection Sections ({{ form.sections.length }})</h5>
                    <div class="card mb-4" v-for="section in form.sections">
                        <div class="card-header">
                            <strong class="mr-2">{{ section.DisplayOrder }}.</strong> {{ section.SectionName }}
                            <label :class="{'badge': true, 'badge-success': section.IsActive == 1, 'badge-warning': section.IsActive != 1}">
                                {{ section.IsActive == 1 ? 'Active' : 'Inactive' }}
                            </label>
                        </div>
                        <div class="card-body">
                            <div class="mb-3" v-for="element in section.elements">
                                <div>
                                    <strong class="mr-2">{{ section.DisplayOrder }}.{{ element.DisplayOrder }}</strong>
                                    <span class="text-info">({{ element.element_score }} pts)</span>
                                    <label :class="{'badge': true, 'badge-success': element.IsActive == 1, 'badge-warning': element.IsActive != 1}">
                                        {{ element.IsActive == 1 ? 'Active' : 'Inactive' }}
                                    </label>
                                </div>
                                {{ element.ElementText }}
                                <div v-if="element.Description || element.osha_standard_url" class="text-muted" style="margin-left: 35px;">
                                    <div v-if="element.Description">{{ element.Description }}</div>
                                    <div v-if="element.osha_standard_url">
                                        <a :href="element.osha_standard_url" target="_blank" title="View OSHA Standard">{{ element.osha_standard_url }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br/>

                    <template v-if="custom_field_sections.length > 0">
                        <h5 class="mt-4">Custom Fields ({{ custom_field_count }})</h5>
                        <incident-sections-builder :sections="custom_field_sections"></incident-sections-builder>
                    </template>
                </div>
                <div class="col-xl-4">
                    <div class="card">
                        <div class="card-header">Sections ({{ form.sections.length }})</div>
                        <div class="card-body">
                            <div v-for="section in form.sections">
                                <strong>{{ section.DisplayOrder }}. </strong>{{ section.SectionName }}
                            </div>
                        </div>
                    </div>

                    <div class="card mt-4" v-if="form.result_labels">
                        <div class="card-header">Result Answer Labels</div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Compliant:</div>
                                <div class="col-md-6">{{ form.result_labels.compliant }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Non-Compliant:</div>
                                <div class="col-md-6">{{ form.result_labels.noncompliant }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">N/A:</div>
                                <div class="col-md-6">{{ form.result_labels.na }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="card mt-4" v-if="form.is_public_form == 1">
                        <div class="card-header">Public QR Code <i class="fa fa-question-circle" title="QR Code to Access the Public Link"></i></div>
                        <div class="card-body" style="overflow-x: auto;">
                            <qr-code :qr_code_url="`${$root.appUrl}/inspections/public/${sds_key}/create?inspection_form_id=${form.inspection_form_id}`"
                                :qr_code_name="'MeritEHS-INSP-'+qrCodeName" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                exporting: false,
                userTimezone: this.$store.state.user.timezone,
                inspection_form_id: this.$route.params.id,
                form: {},
                custom_field_sections: [],
                sds_key: null,
                personnel: [],
            }
        },

        computed: {
            total_score(){
                //Setup
                var score = 0;

                //Loop and Build
                for (var i = this.form.sections.length - 1; i >= 0; i--)
                {
                    //Loop and Continue to Build
                    for (var j = this.form.sections[i].elements.length - 1; j >= 0; j--)
                    {
                        score += this.form.sections[i].elements[j].element_score;
                    }
                }

                //Send it
                return score;
            },

            custom_field_count(){
                //Loop and Build
                var count = 0;

                //Loop and Count
                for (var i = this.custom_field_sections.length - 1; i >= 0; i--)
                {
                    //Append the count
                    count += this.custom_field_sections[i].fields.length;
                }

                //SEnd it
                return count;
            },

            qrCodeName(){
                //Rplace Spaces with Dashboards

                //Clean the Name down to only alphanumeric spaces
                var name = this.form.form_name.replace(/^[\w-]+$/g, '');

                //Send okay
                return name;
            },
        },

        methods: {

            getForm() {
                //Get the data
                this.$http
                    .get('inspections/forms/view/' + this.inspection_form_id)
                    .then(response => {
                        //Set all the data
                        this.form = response.data.form;
                        this.custom_field_sections = response.data.custom_field_sections;
                        this.sds_key = response.data.sds_key;
                        this.personnel = response.data.personnel;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            exportForm() {
                //Helper
                this.exporting = true;

                //Get the data
                this.$http
                    .get('inspections/forms/export/' + this.inspection_form_id)
                    .then(response => {
                        //Set all the data
                        window.location = response.data;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //SEt
                        this.exporting = false;
                    });
            },

            sendToPDF(){
                //Send it
                this.$router.push('/inspections/forms/pdf/'+this.inspection_form_id);
            }
        },

        mounted() {
            //Get the inspections
            this.getForm();
        }
    }
</script>
